import { css } from "styled-components";
export const OverflowContainerHorizontal = css `
  overflow-x: auto;
  overflow-y: hidden;
`;
